<section class="subscription-page">

  <header class="page-header">

    <div>
      <span class="eyebrow">
        Minha assinatura
      </span>

      <h1>
        Plano e faturamento
      </h1>

      <p>
        Consulte seu período de teste,
        renovação mensal e histórico de
        pagamentos.
      </p>
    </div>

    <button
      type="button"
      class="button button-secondary"
      [disabled]="loading"
      (click)="loadSubscription()"
    >
      <span>↻</span>

      {{
        loading
          ? 'Atualizando...'
          : 'Atualizar'
      }}
    </button>

  </header>

  <div
    *ngIf="errorMessage"
    class="alert alert-error"
  >
    {{ errorMessage }}
  </div>

  <div
    *ngIf="successMessage"
    class="alert alert-success"
  >
    {{ successMessage }}
  </div>

  <div
    *ngIf="loading"
    class="loading-card"
  >
    <div class="spinner"></div>

    <span>
      Carregando os dados da assinatura...
    </span>
  </div>

  <ng-container
    *ngIf="
      !loading &&
      subscription
    "
  >

    <section
      class="status-banner"
      [attr.data-status]="
        subscription.status
      "
    >

      <div class="status-banner-icon">
        <ng-container
          [ngSwitch]="subscription.status"
        >
          <span *ngSwitchCase="'TRIAL'">
            ⏱
          </span>

          <span *ngSwitchCase="'ACTIVE'">
            ✓
          </span>

          <span *ngSwitchCase="'PENDING'">
            ⌛
          </span>

          <span *ngSwitchCase="'PAST_DUE'">
            !
          </span>

          <span *ngSwitchDefault>
            •
          </span>
        </ng-container>
      </div>

      <div class="status-banner-content">
        <strong>
          {{ statusLabel }}
        </strong>

        <span>
          {{ statusDescription }}
        </span>
      </div>

    </section>

    <div class="subscription-grid">

      <article class="plan-card">

        <header class="plan-card-header">

          <div>
            <span
              class="status-badge"
              [attr.data-status]="
                subscription.status
              "
            >
              {{ statusLabel }}
            </span>

            <h2>
              {{ subscription.plan.name }}
            </h2>

            <p>
              {{
                subscription.plan.description ||
                'Gestão completa para o seu restaurante.'
              }}
            </p>
          </div>

          <div class="plan-price">
            <strong>
              {{
                formatMoney(planPrice)
              }}
            </strong>

            <span>
              por mês
            </span>
          </div>

        </header>

        <div
          *ngIf="
            subscription.status ===
            'TRIAL'
          "
          class="trial-panel"
        >
          <div class="trial-header">
            <div>
              <strong>
                {{ trialProgressText }}
              </strong>

              <span>
                Seu teste termina em
                {{
                  formatDate(
                    subscription.trialEndsAt
                  )
                }}.
              </span>
            </div>

            <span class="trial-days">
              {{ trialDaysRemaining }}
              {{
                trialDaysRemaining === 1
                  ? 'dia'
                  : 'dias'
              }}
            </span>
          </div>

          <div class="progress-track">
            <div
              class="progress-value"
              [style.width.%]="
                trialProgressPercentage
              "
            ></div>
          </div>

          <small>
            Você não será cobrada durante o
            período de teste.
          </small>
        </div>

        <div class="features-list">

          <div class="feature">
            <span class="feature-check">
              ✓
            </span>

            <span>
              Cardápio digital e QR Codes
            </span>
          </div>

          <div class="feature">
            <span class="feature-check">
              ✓
            </span>

            <span>
              Mesas, comandas e pedidos
            </span>
          </div>

          <div class="feature">
            <span class="feature-check">
              ✓
            </span>

            <span>
              Dashboard e fluxo de caixa
            </span>
          </div>

          <div class="feature">
            <span class="feature-check">
              ✓
            </span>

            <span>
              Equipe e permissões
            </span>
          </div>

        </div>

        <footer class="plan-actions">

          <button
            *ngIf="canSubscribe"
            type="button"
            class="button button-primary"
            (click)="openSubscriptionPayment()"
          >
            💳 Assinar por
            {{ formatMoney(planPrice) }}/mês
          </button>

          <ng-container
            *ngIf="
              canManageActiveSubscription
            "
          >
            <button
              type="button"
              class="button button-secondary"
              (click)="updateCard()"
            >
              Atualizar cartão
            </button>

            <button
              type="button"
              class="button button-danger-link"
              (click)="cancelSubscription()"
            >
              Cancelar assinatura
            </button>
          </ng-container>

          <span
            *ngIf="
              subscription.status ===
              'ACTIVE'
            "
            class="secure-renewal"
          >
            🔒 Renovação automática e segura
          </span>

        </footer>

      </article>

      <aside class="summary-column">

        <article class="summary-card">

          <header>
            <span class="summary-icon">
              🔐
            </span>

            <div>
              <span>
                Situação do acesso
              </span>

              <strong
                [class.access-active]="
                  hasAccess
                "
                [class.access-blocked]="
                  !hasAccess
                "
              >
                {{ accessLabel }}
              </strong>
            </div>
          </header>

          <p>
            {{ accessDescription }}
          </p>

        </article>

        <article class="summary-card">

          <header>
            <span class="summary-icon">
              📅
            </span>

            <div>
              <span>
                Próxima cobrança
              </span>

              <strong>
                {{ nextBillingLabel }}
              </strong>
            </div>
          </header>

          <p>
            A renovação ocorre mensalmente
            após a contratação.
          </p>

        </article>

        <article class="summary-card">

          <header>
            <span class="summary-icon">
              💰
            </span>

            <div>
              <span>
                Valor da mensalidade
              </span>

              <strong>
                {{ formatMoney(planPrice) }}
              </strong>
            </div>
          </header>

          <p>
            O valor poderá ser alterado apenas
            mediante comunicação prévia.
          </p>

        </article>

      </aside>

    </div>

    <section
      id="subscription-payment-area"
      *ngIf="showPaymentArea"
      class="payment-area"
    >

      <header class="section-header">
        <div>
          <span class="eyebrow">
            Pagamento seguro
          </span>

          <h2>
            Contratar Plano Mensal
          </h2>

          <p>
            Seus dados serão processados
            diretamente pelo Mercado Pago.
          </p>
        </div>

        <button
          type="button"
          class="close-button"
          (click)="closeSubscriptionPayment()"
        >
          ×
        </button>
      </header>

  <div
  *ngIf="paymentFormLoading"
  class="payment-form-loading"
>
  <div class="spinner"></div>

  <span>
    Carregando ambiente seguro do
    Mercado Pago...
  </span>
</div>

<form
  id="form-checkout"
  class="checkout-form"
  [class.checkout-form-hidden]="
    paymentFormLoading
  "
>

  <div class="checkout-grid">

    <div class="form-field full-field">
      <label>
        Número do cartão
      </label>

      <div
        id="form-checkout__cardNumber"
        class="mp-secure-field"
      ></div>
    </div>

    <div class="form-field">
      <label>
        Validade
      </label>

      <div
        id="form-checkout__expirationDate"
        class="mp-secure-field"
      ></div>
    </div>

    <div class="form-field">
      <label>
        Código de segurança
      </label>

      <div
        id="form-checkout__securityCode"
        class="mp-secure-field"
      ></div>
    </div>

    <div class="form-field full-field">
      <label
        for="form-checkout__cardholderName"
      >
        Nome impresso no cartão
      </label>

      <input
        id="form-checkout__cardholderName"
        type="text"
        autocomplete="cc-name"
        placeholder="Nome completo"
      />
    </div>

    <div class="form-field">
      <label
        for="form-checkout__identificationType"
      >
        Tipo de documento
      </label>

      <select
        id="form-checkout__identificationType"
      ></select>
    </div>

    <div class="form-field">
      <label
        for="form-checkout__identificationNumber"
      >
        Número do documento
      </label>

      <input
        id="form-checkout__identificationNumber"
        type="text"
        inputmode="numeric"
        placeholder="CPF"
      />
    </div>

    <div class="form-field full-field">
      <label
        for="form-checkout__cardholderEmail"
      >
        E-mail do responsável
      </label>

      <input
        id="form-checkout__cardholderEmail"
        type="email"
        autocomplete="email"
        placeholder="responsavel@restaurante.com"
      />
    </div>

    <!--
      O CardForm utiliza estes campos
      durante a identificação do cartão.
    -->
    <div class="form-field auxiliary-field">
      <label
        for="form-checkout__issuer"
      >
        Banco emissor
      </label>

      <select
        id="form-checkout__issuer"
      ></select>
    </div>

    <div class="form-field auxiliary-field">
      <label
        for="form-checkout__installments"
      >
        Parcelas
      </label>

      <select
        id="form-checkout__installments"
      ></select>
    </div>

  </div>

  <div class="checkout-summary">

    <div>
      <span>
        Cobrança recorrente
      </span>

      <strong>
        {{ formatMoney(planPrice) }}
        por mês
      </strong>
    </div>

    <small>
      Ao confirmar, você autoriza a
      renovação mensal automática.
    </small>

  </div>

  <div class="checkout-actions">

    <button
      type="button"
      class="button button-secondary"
      [disabled]="paymentSubmitting"
      (click)="closeSubscriptionPayment()"
    >
      Voltar
    </button>

    <button
      id="form-checkout__submit"
      type="submit"
      class="button button-primary"
      [disabled]="
        paymentSubmitting ||
        !paymentFormReady
      "
    >
      {{
        paymentSubmitting
          ? 'Processando...'
          : 'Confirmar assinatura'
      }}
    </button>

  </div>

  <div class="payment-security-message">
    <span>🔒</span>

    <p>
      Os dados do cartão são inseridos em
      campos seguros do Mercado Pago. O seu
      sistema recebe apenas um token
      temporário.
    </p>
  </div>

</form>

    </section>

    <section class="history-section">

      <header class="section-header">

        <div>
          <span class="eyebrow">
            Faturamento
          </span>

          <h2>
            Histórico de pagamentos
          </h2>

          <p>
            Acompanhe todas as mensalidades
            processadas para este restaurante.
          </p>
        </div>

      </header>

      <div
        *ngIf="!hasPayments"
        class="empty-history"
      >
        <span>
          🧾
        </span>

        <strong>
          Nenhum pagamento registrado
        </strong>

        <p>
          As mensalidades aparecerão aqui
          depois que a assinatura for
          contratada.
        </p>
      </div>

      <div
        *ngIf="hasPayments"
        class="payment-table-wrapper"
      >

        <table class="payment-table">

          <thead>
            <tr>
              <th>Data</th>
              <th>Referência</th>
              <th>Forma de pagamento</th>
              <th>Valor</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            <tr
              *ngFor="
                let payment of payments
              "
            >
              <td>
                {{
                  getPaymentDate(
                    payment
                  )
                }}
              </td>

              <td>
                {{
                  payment.providerPaymentId
                }}
              </td>

              <td>
                {{
                  getPaymentMethodLabel(
                    payment.paymentMethod
                  )
                }}
              </td>

              <td>
                {{
                  formatMoney(
                    payment.amount
                  )
                }}
              </td>

              <td>
                <span
                  class="payment-status"
                  [attr.data-status]="
                    payment.status
                  "
                >
                  {{
                    getPaymentStatusLabel(
                      payment.status
                    )
                  }}
                </span>
              </td>
            </tr>
          </tbody>

        </table>

      </div>

    </section>

  </ng-container>

  <div
    *ngIf="
      !loading &&
      !subscription &&
      !errorMessage
    "
    class="empty-card"
  >
    <span>
      ⚠
    </span>

    <strong>
      Nenhuma assinatura encontrada
    </strong>

    <p>
      Não foi possível encontrar um plano
      relacionado a este restaurante.
    </p>
  </div>

</section>